// Packages
// import { useEffect, useState } from "react";

// Elements
import { Main, Container } from "./NotFound.elements";

// Components
import Hero from "../Listing/Hero";
import Copy from "./Copy";
import Footer from "./Footer";

export default function NotFound() {
  return (
    <Main>
      <Hero />
      <Container>
        <Copy />
        <Footer />
      </Container>
    </Main>
  );
}
